import React from 'react';
import { Col } from '@cvent/carina/components/Col';
import { Row } from '@cvent/carina/components/Row';

type TextWithLinkContainerProps = {
  testID: string;
  children: {
    text?: React.ReactNode;
    link?: React.ReactNode;
    tooltip?: React.ReactNode;
  };
};

export const TextWithLinkContainer = ({ testID, children }: TextWithLinkContainerProps): JSX.Element => {
  const { text, link, tooltip } = children;

  return (
    <Row justifyContent={'center'} testID={`${testID}__row`}>
      {text && (
        <Col width={'content'} padding={4} testID={`${testID}__text_col`}>
          {text}
        </Col>
      )}
      {link && (
        <Col width={'content'} padding={4} testID={`${testID}__link_col`}>
          {link}
        </Col>
      )}
      {tooltip && (
        <Col width={'content'} padding={4} testID={`${testID}__tooltip_col`}>
          {tooltip}
        </Col>
      )}
    </Row>
  );
};
